import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_TRAVEL_INTERRUPTION_STATE,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    itineraryChange: 'false',
    dateTripWasDelayedWithTravelSupplier: '',
    dateDelayEndedForDelay: '',
    detailsRegardingYourTripDelay: '',
    lossInformationItems: [],
    dateYouWereNotifiedOfChangeByCruiseLine: '',
    datesChangedByCruiseLine: '',
    dateDelayEnded: '',
    descriptionOfReasonForChangeInItinerary: '',
    companyNameForOther: '',
    addressForOther: '',
    typeOfPolicyForOther: '',
    policyForOther: '',
    contactForOther: '',
    phoneForOther: '',
    cityOrTownForOther: '',
    countryForOther: '',
    postalCodeForOther: '',
  },
  errors: [],
});

const initialTravelInterruptionState = {
  form: {
    travelMissedConnection: 'false',
    companyNameTravelDelay: '',
    addressTravelDelay: '',
    cityTravelDelay: '',
    stateTravelDelay: '',
    zipCodeTravelDelay: '',
    contactTravelDelay: '',
    phoneNumberTravelDelay: '',
    dateOfInitialPaymentDeposit: '',
    includedInPackageForDelay: '',
    dateTripWasDelayedWithTravelSupplier: '',
    dateDelayEndedForDelay: '',
    detailsRegardingYourTripDelay: '',
    lossInformationItems: [],
  },
};

function itineraryChangeReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_TRAVEL_INTERRUPTION_STATE:
      return state
           .setIn(['form', 'lossInformationItems'], [])
           .mergeDeep(initialTravelInterruptionState);
    default:
      return state;
  }
}

export default itineraryChangeReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.CFTripCan.ItineraryChange/reducer.js